import React from 'react';

const VolumeHeader = () => {
  return (
    <div className="overflow-hidden hidden">
      {/* just leaving empty for now. */}
    </div>
  );
};

export default VolumeHeader;
